var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 68,
    viewBox: "0 0 71 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_2361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3602 20.9028C32.3446 20.9028 30.404 21.6867 28.979 23.0979L26.0821 25.9386C24.9102 27.0915 23.0071 27.0915 21.8352 25.9386C20.6633 24.7857 20.6633 22.9134 21.8352 21.7605L24.7321 18.9198C27.2915 16.4111 30.7508 15 34.3602 15C41.8696 15 47.9633 20.995 47.9633 28.3827C47.9633 31.9336 46.529 35.3369 43.979 37.8456L31.2102 50.4167H47.9633C49.6227 50.4167 50.9633 51.7356 50.9633 53.3681C50.9633 55.0005 49.6227 56.3194 47.9633 56.3194H23.9633C22.754 56.3194 21.6571 55.6 21.1883 54.4933C20.7196 53.3865 20.9821 52.1229 21.8352 51.2744L39.7321 33.6768C41.1571 32.2748 41.9633 30.3657 41.9633 28.3827C41.9633 24.2508 38.5602 20.9028 34.3602 20.9028Z",
    fill: "#EE7733"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_2361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 47.2222,
    fill: "white",
    transform: "translate(20.9563 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoIcon);
export default __webpack_public_path__ + "static/media/two-icon.46fb68a9311683de91f8b0b31bfda9e8.svg";
export { ForwardRef as ReactComponent };